export const identity = value => value;
export const object = (value, _default = {}) => value || _default;
export const array = value => object(value, []);
export const checkNested = (obj, level, ...rest) => {
    if (obj === undefined) return false
    if (rest.length == 0 && obj.hasOwnProperty(level)) return true
    return checkNested(obj[level], ...rest)
}
